import { inject, Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';
import { CommonService } from 'src/app/services/common.service';
import { environment } from 'src/environments/environment';
import { LoginService } from './login.service';
@Injectable({
  providedIn: 'root',
})
export class OAuth2Guard {
  private cookieService = inject(CookieService)
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  ON_PREMISES = environment.ON_PREMISES;
  ON_PREMISES_CAS = environment.ON_PREMISES_CAS;
  ON_CLOUD = environment.ON_CLOUD;
  PROFILE = environment.ENV_ACTIVE_PROFILE;
  ON_CUSTOMIDP = environment.ON_CUSTOMIDP;
  hasIdtoken: any;
  hasAccessToken: any;
  userdispName: any;
  envUrlList: any;
  userId: string;
  constructor(
    private oauthService: OAuthService,
    private commonService: CommonService,
    private loginService: LoginService
  ) { }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    // OIDC enviroment (OKTA,o Auth0, etc....)
    if (this.PROFILE === this.ON_PREMISES) {
      // onPremises enviroment
      if (sessionStorage.getItem('nonce')) {
        return true;
      } else {
        this.oauthService.initLoginFlow();
        return false;
      }
    }
    // Congito environment
    else if (this.PROFILE === this.ON_CLOUD) {
      if (sessionStorage.getItem('isLogin') !== 'yes') {
        this.loginService.redirectToLogin();
      } else {
        return true;
      }
    }
    // CAS environment
    else if (this.PROFILE === this.ON_PREMISES_CAS) {
      if (sessionStorage.getItem('isLogin') !== 'yes') {
        this.loginService.CAS_LoginPage();
      } else {
        return true;
      }
    } else if (this.PROFILE === this.ON_CUSTOMIDP) {
      return this.onCustomIdp(state.url);
    }
  }

  async normalCloud() {
    let tokenInfo = this.commonService.get_tokenInfo();
    //normal cloude
    const firstName = tokenInfo.given_name;
    const secondName = tokenInfo.family_name;
    this.userdispName = firstName + secondName;
    if (tokenInfo.identities != undefined) {
      this.userId = tokenInfo.identities[0].userId;
    } else {
      this.userId = tokenInfo.email;
    }
  }

  getNavigation(res) {
    this.commonService
      .getNavigationUrl(
        res.userId,
        res.profile[0].lob,
        res.profile[0].roleType
      )
      .then((ress) => {
        localStorage.setItem('userRole', ress.envUrl[0].value)
        this.envUrlList = ress.envUrl[0].label;
        if (res.profile[0].lob === 'L' || res.profile[0].lob == 'C_L' || res.profile[0].lob === 'A') {
          let region =
            this.envUrlList == '/UnderWriter'
              ? `Region-${res.profile[0].country}`
              : res.profile[0].country;
          window.open(
            environment[ress.envUrl[0].value] + this.envUrlList + '/' + region,
            '_self'
          );
        } else {
          let domain = environment.WEB_DOMAIN
          let envUrl = this.envUrlList.split('/')
          if (ress.envUrl[0].value === 'P_CO') {
            this.cookieService.set('access_token', sessionStorage.getItem('access_token'), 20000, `/${envUrl[1]}`, domain)
            this.cookieService.set('userName', localStorage.getItem('userId'), 20000, `/${envUrl[1]}`, domain)
          }
          this.cookieService.set('locale', sessionStorage.getItem('regionSelected'), 20000, `/${envUrl[1]}`, domain)
          window.open(
            environment[ress.envUrl[0].value] + this.envUrlList,
            '_self'
          );
        }
      });
  }


  async getUserRoleCloud() {
    this.loginService.getUserRoles(this.userId).then((res) => {
      console.log('userRole', res);
      if (
        res.userName != null &&
        res.userName != undefined &&
        res.userName != ''
      ) {
        localStorage.setItem('profilename', res.userName);
        localStorage.setItem('userdispName', res.userName);
        localStorage.setItem('fullNameUser', res.userName);
      }
      if (res && res.profile.length == 1) {
        this.getNavigation(res);
      }
    });
  }

  private isTokenValid(): boolean {
    const token = localStorage.getItem('access_token') || sessionStorage.getItem('access_token');
    if (!token || token === '') {
      return false;
    }
    const tokenSetTime = localStorage.getItem('token_set_time');
    const expiresIn = localStorage.getItem('expires_in');
    if (!tokenSetTime || !expiresIn) {
      return true;
    }
    const currentTime = Math.floor(Date.now() / 1000);
    const tokenAge = currentTime - parseInt(tokenSetTime, 10);
    const expirationTime = parseInt(expiresIn, 10);
    return tokenAge < (expirationTime - 30);
  }

  private clearAuthData(): void {
    localStorage.clear();
    sessionStorage.clear();
    this.deleteCookie('access_token');
    this.deleteCookie('username');
    this.deleteCookie('userName');
    this.deleteCookie('channel');
  }

  private deleteCookie(name: string): void {
    try {
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
      const domain = window.location.hostname;
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${domain};`;
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.${domain};`;
    } catch (error) {
    }
  }

  async onCustomIdp(url: string): Promise<boolean | UrlTree> {
    const queryString = url.split('?')[1] || '';
    const params = new URLSearchParams(queryString);
    const authCode = params.get('authCode');

    if (!authCode) {
      const hasToken = !!(localStorage.getItem('access_token') || sessionStorage.getItem('access_token'));

      if (!hasToken) {
        window.location.href = environment.ON_CUSTOMIDP_Auth.LoginUrl;
        return false;
      }

      if (!this.isTokenValid()) {
        this.clearAuthData();
        window.location.href = environment.ON_CUSTOMIDP_Auth.LoginUrl;
        return false;
      }

      return true;
    }

    try {
      const res = await this.loginService.exchangeAuthCodeForToken(authCode);

      if (res && res.data) {
        this.clearAuthData();

        localStorage.setItem('isSignUp', 'N');

        const token = res.data.access_token;
        if (token !== undefined) {
          const currentTime = Math.floor(Date.now() / 1000);
          localStorage.setItem('userToken', token);
          localStorage.setItem('access_token', token);
          localStorage.setItem('token_set_time', String(currentTime));
          sessionStorage.setItem('access_token', token);
        }

        if (res.data.refresh_token) {
          localStorage.setItem('refresh_token', res.data.refresh_token);
          sessionStorage.setItem('refresh_token', res.data.refresh_token);
        }

        if (res.data.id_token) {
          localStorage.setItem('id_token', res.data.id_token);
          sessionStorage.setItem('id_token', res.data.id_token);
        }

        if (res.data.expires_in) {
          localStorage.setItem('expires_in', String(res.data.expires_in));
          sessionStorage.setItem('expires_in', String(res.data.expires_in));
        }

        if (res.data.refresh_expires_in) {
          localStorage.setItem('refresh_expires_in', String(res.data.refresh_expires_in));
          sessionStorage.setItem('refresh_expires_in', String(res.data.refresh_expires_in));
        }

        if (res.data.token_type) {
          localStorage.setItem('token_type', res.data.token_type);
          sessionStorage.setItem('token_type', res.data.token_type);
        }

        if (res.data['not-before-policy'] !== undefined) {
          localStorage.setItem('not_before_policy', String(res.data['not-before-policy']));
          sessionStorage.setItem('not_before_policy', String(res.data['not-before-policy']));
        }

        if (res.data.scope) {
          localStorage.setItem('scope', res.data.scope);
          sessionStorage.setItem('scope', res.data.scope);
        }

        if (res.data.session_state) {
          localStorage.setItem('session_state', res.data.session_state);
          sessionStorage.setItem('session_state', res.data.session_state);
        }

        if (res.data.token_iss) {
          localStorage.setItem('token_iss', res.data.token_iss);
          sessionStorage.setItem('token_iss', res.data.token_iss);
        }

        const userProfile = res.data.userProfile || res.data;

        const userName = userProfile.username;
        if (userName && userName !== 'null' && userName !== 'undefined') {
          localStorage.setItem('userName', userName);
          sessionStorage.setItem('userName', userName);
          localStorage.setItem('fullNameUser', userName);
          localStorage.setItem('userId', userName);
          localStorage.setItem('subNumber', userName);
        }

        const employName = userProfile.employName;
        if (employName && employName !== 'null' && employName !== 'undefined') {
          localStorage.setItem('employ_name', employName);
          sessionStorage.setItem('employ_name', employName);
          localStorage.setItem('fullNameUser', employName);
        }

        const selectedRole = userProfile.selectedRole || 'N_GS';
        if (selectedRole && selectedRole !== 'null' && selectedRole !== 'undefined') {
          localStorage.setItem('selected_role', selectedRole);
          sessionStorage.setItem('selected_role', selectedRole);
        }

        if (userProfile.sub) {
          localStorage.setItem('sub', userProfile.sub);
          sessionStorage.setItem('sub', userProfile.sub);
        }

        if (userProfile.emailVerified !== undefined) {
          localStorage.setItem('email_verified', String(userProfile.emailVerified));
          sessionStorage.setItem('email_verified', String(userProfile.emailVerified));
        }

        const clientNumber = userProfile.clientNumber;
        if (clientNumber && clientNumber !== 'null' && clientNumber !== 'undefined') {
          localStorage.setItem('clientNumber', clientNumber);
          sessionStorage.setItem('clientNumber', clientNumber);
          localStorage.setItem('userId', clientNumber);
          localStorage.setItem('subNumber', clientNumber);
        }

        const clientName = userProfile.clientName;
        if (clientName && clientName !== 'null' && clientName !== 'undefined') {
          localStorage.setItem('clientName', clientName);
          sessionStorage.setItem('clientName', clientName);
        }

        const memberNumber = userProfile.memberNumber;
        if (memberNumber && memberNumber !== 'null' && memberNumber !== 'undefined') {
          localStorage.setItem('member_number', memberNumber);
          sessionStorage.setItem('member_number', memberNumber);
        }

        const policyNumber = userProfile.policyNumber;
        if (policyNumber && policyNumber !== 'null' && policyNumber !== 'undefined') {
          localStorage.setItem('policy_number', policyNumber);
          sessionStorage.setItem('policy_number', policyNumber);
        }

        if (userProfile.userType) {
          localStorage.setItem('userType', userProfile.userType);
          sessionStorage.setItem('userType', userProfile.userType);
        }

        const country = userProfile.country || 'IDN';
        localStorage.setItem('country', country);
        sessionStorage.setItem('regionSelected', country);

        if (!localStorage.getItem('language')) {
          localStorage.setItem('language', environment.language);
        }

        if (!localStorage.getItem('lob')) {
          const defaultLob = res.data.token_iss === 'agent' ? 'N' : 'L';
          localStorage.setItem('lob', defaultLob);
          sessionStorage.setItem('lob', defaultLob);
        }

        setTimeout(() => {
          window.dispatchEvent(new CustomEvent('customidp-auth-complete'));
        }, 100);

        const currentPath = url.split('?')[0];
        return this.router.parseUrl(currentPath);
      } else {
        this.clearAuthData();
        window.location.href = environment.ON_CUSTOMIDP_Auth.LoginUrl;
        return false;
      }
    } catch (error) {
      this.clearAuthData();
      window.location.href = environment.ON_CUSTOMIDP_Auth.LoginUrl;
      return false;
    }
  }
}
